/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const castVote = /* GraphQL */ `
  mutation CastVote($input: castVoteInput) {
    castVote(input: $input) {
      status
      message
      pollId
      updatedCounts
      __typename
    }
  }
`;
export const createNewPoll = /* GraphQL */ `
  mutation CreateNewPoll($input: createNewPollInput) {
    createNewPoll(input: $input) {
      pollId
      title
      message
      description
      category
      options {
        optionId
        text
        __typename
      }
      status
      target_type
      target_value
      start_time
      end_time
      vote_counts
      created_at
      subscription_topic
      poll_display_id
      knowledge_base_url
      age_group
      __typename
    }
  }
`;
export const deleteOrDeactivatePoll = /* GraphQL */ `
  mutation DeleteOrDeactivatePoll($input: deleteOrDeactivatePollInput) {
    deleteOrDeactivatePoll(input: $input)
  }
`;
export const createAdminUser = /* GraphQL */ `
  mutation CreateAdminUser($input: createAdminUserInput) {
    createAdminUser(input: $input)
  }
`;
export const updateAdminUser = /* GraphQL */ `
  mutation UpdateAdminUser($input: updateAdminUserInput) {
    updateAdminUser(input: $input)
  }
`;
export const listAdminUsers = /* GraphQL */ `
  mutation ListAdminUsers($input: listAdminUsersInput) {
    listAdminUsers(input: $input)
  }
`;
export const deleteAdminUser = /* GraphQL */ `
  mutation DeleteAdminUser($input: deleteAdminUserInput) {
    deleteAdminUser(input: $input)
  }
`;
export const requestPollCreation = /* GraphQL */ `
  mutation RequestPollCreation($input: requestPollCreationInput) {
    requestPollCreation(input: $input)
  }
`;
export const approveOrRejectPollCreationWorkFlow = /* GraphQL */ `
  mutation ApproveOrRejectPollCreationWorkFlow(
    $input: approveOrRejectPollCreationWorkFlowInput
  ) {
    approveOrRejectPollCreationWorkFlow(input: $input)
  }
`;
export const getRecentlyCompletedPolls = /* GraphQL */ `
  mutation GetRecentlyCompletedPolls {
    getRecentlyCompletedPolls
  }
`;
export const editPoll = /* GraphQL */ `
  mutation EditPoll($input: editPollInput) {
    editPoll(input: $input)
  }
`;
export const reportPoll = /* GraphQL */ `
  mutation ReportPoll($input: reportPollInput) {
    reportPoll(input: $input)
  }
`;
export const requestForCuratorAccess = /* GraphQL */ `
  mutation RequestForCuratorAccess($input: requestForCuratorAccessInput) {
    requestForCuratorAccess(input: $input)
  }
`;
export const approveRejectCuratorRequest = /* GraphQL */ `
  mutation ApproveRejectCuratorRequest(
    $input: approveRejectCuratorRequestInput
  ) {
    approveRejectCuratorRequest(input: $input)
  }
`;
export const acknowledgePollReport = /* GraphQL */ `
  mutation AcknowledgePollReport($input: acknowledgePollReportInput) {
    acknowledgePollReport(input: $input)
  }
`;
export const createPrivatePoll = /* GraphQL */ `
  mutation CreatePrivatePoll($input: requestPollCreationInput) {
    createPrivatePoll(input: $input)
  }
`;
export const storeUserScratchPad = /* GraphQL */ `
  mutation StoreUserScratchPad($input: storeUserScratchPadInput) {
    storeUserScratchPad(input: $input)
  }
`;
export const verifyPasscode = /* GraphQL */ `
  mutation VerifyPasscode($input: verifyPasscodeInput) {
    verifyPasscode(input: $input)
  }
`;
export const askAIForQuestion = /* GraphQL */ `
  mutation AskAIForQuestion($input: askAIForQuestion) {
    askAIForQuestion(input: $input)
  }
`;
export const onboardUser = /* GraphQL */ `
  mutation OnboardUser($input: onboardUserInput) {
    onboardUser(input: $input)
  }
`;
